module.exports = __webpack_public_path__ + "img/bg_shendu@2x.336e4744.png";